<template>
  <v-container
    class="order-items-view-container"
    fluid
  >
    <h1>Order Items</h1>
    <order-items-table
      :order-items="orderItems"
      :order-items-pagination="orderItemsPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { OrderItemsTable } from '@/components/baader';

export default {
  name: 'OrderItems',
  components: {
    'order-items-table': OrderItemsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.orderItemsStore.loading,
      orderItems: state => state.orderItemsStore.orderItems,
      orderItemsPagination: state => state.orderItemsStore.orderItemsPagination,
    }),
  },
  async mounted() {
    this.getOrderItems(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getOrderItems']),
  },
};
</script>


<style lang="scss" scoped>
.order-items-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/OrderItems.vue